import React, { useState, useContext, useEffect } from 'react';
import { USER_FORM } from '../ModalTemplate';
import { TabPanel } from "../Common/TabPanel"
import InnerHeader from '../Common/InnerHeader';
import { ModalContext } from '../../Context'
import { allAdminUsers, allUsers, getEducationData, GetEducationSubSessiondata, getResources ,gettoolkitsCategory } from '../../Utils/services';
import { toast } from 'react-toastify';
import AdminForm from '../ModalTemplate/AdminForm';
import UserForm from '../ModalTemplate/UserForm';
import Loader from "../Common/Loader"
import { useTranslation } from 'react-i18next';
// import ToolResource from './ToolResource';
// import AddResourcesForm from '../ModalTemplate/AddResourcesForm';
import AddToolkitform from '../ModalTemplate/AddToolkitform';
import EducationSessionResources from './EducationSessionResources';
import AddCourse from '../ModalTemplate/AddCourse';
import EducationSubSessionResources from './EducationSubSessionResources';
import { useNavigate, useLocation } from 'react-router-dom';
import AddSubSession from '../ModalTemplate/AddSubSession';


const a11yProps = (index) => {
  console.log(index, "index, ")
  return {
    id: `users-tab-${index}`,
    'aria-controls': `users-tabpanel-${index}`,
  };
}

const EducationSubSession = ({match}) => {

  const {t} = useTranslation();

  const [tabsValue, setTabsValue] = useState(0);
  const [ResourcesData, setResourcesData] = useState([]);
  const context = useContext(ModalContext)
  const { handleModalData } = context;
  const [loader, setLoader] = useState(true);
  const [adminData, setAdminData] = useState([]);

  const handlerTabs = (event, newValue) => {
    setTabsValue(newValue);
  };

  const getAdminTableData = async () => {
    try {
      const result = await allAdminUsers();
      if (result.data.length > 0) {
        
        setLoader(false)
        setAdminData(result.data);
      }
    }
    catch (error) {
      setLoader(false)
      toast.error(error.message);
    }
  }
  const location = useLocation();
  const CourseId = location?.state?.data
  const SessionId = location?.state?.sessionid
  const Sessionname = location?.state?.title?.session
  const coursename = location?.state?.coursename
  
  
  const getTablesData = async () => {
    try {
      const result = await GetEducationSubSessiondata({
        courseId: CourseId,
        sessionId: SessionId,

      });
      console.log(result,"result")
      
      setResourcesData(result?.res?.sub_Session.reverse())
     
      setLoader(false)
    }
    catch (error) {
      setLoader(false)
      console.log(error, "Error");
      toast.error(error.message);
    }
  }

  useEffect(() => {
    getTablesData();
    getAdminTableData();
  }, [])
  
  const tabsData = [
    {
      label: `${t("SubSession")}`,
      isNotshowAdd : adminData[0]?.AdminType === "Coordination team" ? true : false,
      data: (
        <>
          <Loader loader={loader} />
          <EducationSubSessionResources data={ResourcesData} getTablesData={getTablesData} adminData={adminData} Sessionname={Sessionname} coursename={coursename}/>
        </>
      )
    },
  ]

  const handleModalForm = () => {
    switch (tabsValue) {
      case 0:
        handleModalData(<AddSubSession SessionId={SessionId} CourseId={CourseId} getFeedData={getTablesData} title="add SubSession" buttonText="add SubSession" />);
        break;
      default:
        handleModalData(<AddSubSession SessionId={SessionId} CourseId={CourseId} getFeedData={getTablesData} title="add SubSession" buttonText="add SubSession"  />);
        break;
    }
  }
  console.log(tabsData, "tabsData")

  return (
    <div className="relative">
      <InnerHeader
        tabsData={tabsData}
        handleModalForm={handleModalForm}
        tabsValue={tabsValue}
        handlerTabs={handlerTabs}
        a11yProps={a11yProps}
        formBtn
      />

      {
        tabsData.map((obj, index) => (
          <TabPanel
            className="px-10"
            value={tabsValue}
            index={index}
          >
            {obj.data}
          </TabPanel>
        ))
      }
    </div>
  );
}


export default EducationSubSession;

